'use strict';

import HistoryDatabase from '@HistoryDatabase';

export default HistoryDatabase;
